import HeaderModal from "../headerModal/headerModal";
import SugerenciaCmp from "../Sugerencias/SugerenciaCmp";
import "./CalificarMisMedicos.css"

const SugerenciaMedicos = ({titulo, dissmiss, danger}) => {
  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={danger}/>
        <div className="ptur-sugerenciaMisMedicos-container">
            <SugerenciaCmp/>
        </div>
   </>
  );
};

export default SugerenciaMedicos;